import { useQuery } from '@tanstack/react-query';
import { LeadQuery } from '@troia-v3/types';
import { leadsService } from '../services';

/**
 * Hook para buscar lista de leads com filtros e paginação
 *
 * @param query - Parâmetros de filtro e paginação
 * @returns Query result com dados, loading e error states
 *
 * @example
 * ```tsx
 * const { data, isLoading, error, refetch } = useLeads({
 *   page: 1,
 *   limit: 20,
 *   filters: { funnelId: 'sales', priority: 'high' }
 * });
 * ```
 */
export const useLeads = (query?: LeadQuery, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['leads', query],
    queryFn: () => leadsService.getLeads(query),
    staleTime: 30 * 1000, // 30 seconds
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
};
